import { render, staticRenderFns } from "./NoItemAlert.vue?vue&type=template&id=31ce7980&scoped=true&"
var script = {}
import style0 from "./NoItemAlert.vue?vue&type=style&index=0&id=31ce7980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce7980",
  null
  
)

export default component.exports